import { Component, HostBinding, Input } from "@angular/core";

@Component({
  selector: "blinker-svg",
  templateUrl: "./blinker.component.svg",
  styleUrls: ["./blinker.component.scss"],
})
export class BlinkerSvgComponent {

  @Input() width: number;

  @HostBinding('style.width') get _width() {
    return this.width ? this.width + 'px' : '';
  }

  @Input() height: number;

  @HostBinding('style.height') get _height() {
    return this.height ? this.height + 'px' : '';
  }
}
